// global instance of teams-js
export let teamsClient: any;

export const loadTeamsJS = async () => {
  if (teamsClient) {
    console.log("[teams-js] teams-js is already initialized.")
    return teamsClient;
  }

  try {
    teamsClient = await import('@microsoft/teams-js');
    teamsClient.initialize();
  }
  catch (exception) {
    // In the rare possibility it fails, track the internal exception 
    // and log to console for debugging purposes
    console.error("[teamsjs] Unable to initialize teams-js!")

    // Reset the client
    teamsClient = null;
    throw exception;
  }

  return teamsClient;
}

export const getTeamsAuthToken = async (
  onSuccess: (accessToken: string) => void,
  onError: (error: Error) => void,
  _teamsClient: any = teamsClient // unit testing purposes only!
) => {
  if (!_teamsClient) {
    _teamsClient = await loadTeamsJS();
  }

  var authTokenRequest = {
    successCallback: (accessToken: string) => {
      return onSuccess && onSuccess(accessToken);
    },
    failureCallback: (error: any) => {
      onError && onError(error);
    },
  };

  _teamsClient.authentication.getAuthToken(authTokenRequest);
};